<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mKlBZI/tc-custom/9781627798242.jpg?1739474053126" alt="This image is the cover for the book Gold Digger"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gold Digger
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A good biography of a bad girl,” an account of the first tabloid celebrity, a woman who made a career of marrying millionaires (</b><i><b>The New Yorker</b></i><b>).</b><br/> </p><p>One of America's most talked about personalities during the Jazz Age, Peggy Hopkins Joyce was the quintessential gold digger, the real-life Lorelei Lee. Married six times, to several millionaires and even a count, Joyce had no discernible talent except self-promotion. A barber's daughter from Norfolk, Virginia, who rose to become a Ziegfeld Girl and, briefly, a movie star, Joyce was the precursor of the modern celebrity—a person famous for being famous. Her scandalous exploits—spending a million dollars in a week, conducting torrid love affairs with the likes of Charlie Chaplin and Walter Chrysler—were irresistible to the new breed of tabloid journalists in search of sensation and to audiences hungry for the possibilities her life seemed to promise. </p><p>Joyce's march across Broadway, Hollywood, and the nation's front pages was only slowed by the true nemesis of the glamour girl: old age. She died in 1957, alone and forgotten—until now. In prose as vibrant as its subject, Constance Rosenblum's <i>Gold Digger</i> brings to life the woman who singularly epitomized this confident and hedonistic era.</p><p>“Entertaining and meticulously researched.<i>” —The New York Times Book Review</i> </p><p><br/>"Compelling as any tabloid serial, <i>Gold Digger</i> is a brilliant parable for both the power and perishability of celebrity. Unputdownable” —Neal Gabler, award-winning author of <i>Life the Move</i><br/><br/>"<i>Gold Digger</i> pairs a scandalous vamp living in an unbridled era with an entertaining and resourceful journalist—delicious!" —<i>USA Today</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Constance Rosenblum
      </h2>
      
      <p class="authorDescription body article">Constance Rosenblum, a journalist at The New York Times, was for many years editor of the paper's Arts and Leisure section. She lives in Brooklyn.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e9a6ebf